/* Make items parallax.  Use '.parallax-item' class on items to be parallax. */
function outerHeight(el, includeMargin) {
    if (el != null) {
        var height = el.offsetHeight;
        if (includeMargin) {
            var style = el.currentStyle || getComputedStyle(el);
            height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        }
        return height;
    }
}

var translateElement = function(element, valueY) {

	if ( valueY < 0 ) {
		valueY = 0;
	}
    var translate = 'translate3d(0, ' + valueY + 'px' + ', 0) rotate(0.01deg)';
    element.style['-webkit-transform'] = translate;
    element.style['-moz-transform'] = translate;
    element.style['-ms-transform'] = translate;
    element.style['-o-transform'] = translate;
    element.style['transform'] = translate;
}


var parallaxCols = document.querySelectorAll('.parallax-item');
var bodyTop = document.documentElement.scrollTop || document.body.scrollTop;
var wwidth = window.innerWidth || document.documentElement.clientWidth;
var wheight = window.innerHeight || document.documentElement.clientHeight;
var speedDivider = 0.25;
var uri_pattern = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;


function parallaxRowCol(bodyTop) {
	for (var j = 0; j < parallaxCols.length; j++) {
	    var section = parallaxCols[j].parentNode,
	        thisHeight = outerHeight(parallaxCols[j]),
	        sectionHeight = outerHeight(section),
	        offSetTop = bodyTop + (section != null ? section.getBoundingClientRect().top : 0),
	        offSetPosition = wheight + bodyTop - offSetTop;
	    if (offSetPosition > 0 && offSetPosition < (sectionHeight + wheight)) {
	        value = ((offSetPosition - wheight) * speedDivider);
	        value *= .8;
	        if (Math.abs(value) < (thisHeight - sectionHeight)) {
	            translateElement(parallaxCols[j], value);
	        } else {
	            translateElement(parallaxCols[j], value );
	        }
	    }
	}
}

var scrollFunction = function() {
	parallaxRowCol(bodyTop);
};

window.addEventListener('scroll', function(e) {
	bodyTop = document.documentElement.scrollTop || document.body.scrollTop;
	scrollFunction();
}, false);

window.addEventListener('resize', function(e) {
	scrollFunction();
});

window.addEventListener('load', function(e) {
	scrollFunction();
});